import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61ae5016"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Make a Payment")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Add Credit")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Fees/Products")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Edit profile ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Rent a unit ")
const _hoisted_8 = { class: "alert-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Customer has a Lien Status", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Customer has a Auction Status", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Customer has a Delinquent Status", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"margin-top":"20px"} }, "Customer information", -1))
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "row horizontal-start" }
const _hoisted_15 = {
  key: 0,
  class: "small-box"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Photo Identification", -1))
const _hoisted_17 = { class: "column" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Add Photo ")
const _hoisted_20 = {
  key: 1,
  class: "btn btn-text"
}
const _hoisted_21 = { class: "box" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Contact", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Account Number", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Name:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Email:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Access Code:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Phone:", -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Address:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Driver's license", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "License Plate", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Vehicle Description", -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Edit profile ")
const _hoisted_37 = {
  key: 1,
  class: "box"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Accounts & Access", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Username:", -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Online web password was created for tenant")
const _hoisted_41 = { key: 2 }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Login not created. Go to \"Edit Profile\" to add info. In order to rent a unit, a customer is ")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "required", -1))
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" to sign up for an account. ")
const _hoisted_45 = [
  _hoisted_42,
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { style: {"margin-bottom":"15px"} }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Make a Payment")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("View")
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Recurring Billing")
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Rentals", -1))
const _hoisted_55 = { class: "alert-box" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Customer has a Lien Status", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Customer has a Auction Status", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Customer has a Delinquent Status", -1))
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "row horizontal-between" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Unit", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Lease Agreement", -1))
const _hoisted_63 = {
  key: 0,
  style: {"color":"green"}
}
const _hoisted_64 = {
  key: 1,
  style: {"color":"rgb(194, 22, 22) !important"}
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Details", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Size", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Status:", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Gate Key:", -1))
const _hoisted_70 = ["onClick"]
const _hoisted_71 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_72 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Update ")
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Access Instructions:", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Combination Lock Number:", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Move-in Date:", -1))
const _hoisted_78 = { key: 5 }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Insurance:", -1))
const _hoisted_80 = { key: 6 }
const _hoisted_81 = {
  key: 7,
  style: {"margin-left":"20px"}
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Self-Insured", -1))
const _hoisted_83 = { style: {"margin-left":"10px"} }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_85 = { key: 8 }
const _hoisted_86 = /*#__PURE__*/_createTextVNode("Edit Rental")
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Billing", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Next Bill:", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Paid to:", -1))
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { key: 2 }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Balance:", -1))
const _hoisted_93 = { key: 3 }
const _hoisted_94 = { key: 4 }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Next Rate Change:", -1))
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Move Out", -1))
const _hoisted_99 = { key: 0 }
const _hoisted_100 = /*#__PURE__*/_createTextVNode(" Finalize Move Out ")
const _hoisted_101 = /*#__PURE__*/_createTextVNode(" Schedule Move Out ")
const _hoisted_102 = { key: 3 }
const _hoisted_103 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_104 = {
  key: 0,
  class: "custom-box delete-box"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Are you sure you want to cancel move out?", -1))
const _hoisted_106 = ["onClick"]
const _hoisted_107 = ["onClick"]
const _hoisted_108 = {
  key: 1,
  class: "text-center"
}
const _hoisted_109 = { key: 3 }
const _hoisted_110 = { key: 4 }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = {
  key: 0,
  class: "row horizontal-between"
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Unit", -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Details", -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Size", -1))
const _hoisted_116 = { key: 0 }
const _hoisted_117 = { key: 1 }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Date Reserved:", -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Desired Move-in Date:", -1))
const _hoisted_120 = { key: 0 }
const _hoisted_121 = /*#__PURE__*/_createTextVNode("Complete")
const _hoisted_122 = ["onClick"]
const _hoisted_123 = {
  key: 1,
  class: "custom-box delete-box"
}
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Are you sure you want to delete?", -1))
const _hoisted_125 = { class: "form-delete row" }
const _hoisted_126 = ["onSubmit"]
const _hoisted_127 = {
  key: 0,
  class: "form-field"
}
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Reason", -1))
const _hoisted_129 = ["value"]
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-outline-blue"
}, " Finish ", -1))
const _hoisted_131 = {
  key: 1,
  class: "text-center"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Billing History", -1))
const _hoisted_133 = { class: "" }
const _hoisted_134 = { key: 0 }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Date")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Description")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Service Period")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Promo")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Charge")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Payment")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Balance")
  ])
], -1))
const _hoisted_136 = { key: 0 }
const _hoisted_137 = { key: 0 }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_141 = { key: 1 }
const _hoisted_142 = { key: 2 }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_144 = { key: 0 }
const _hoisted_145 = { key: 1 }
const _hoisted_146 = { key: 2 }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_148 = { key: 3 }
const _hoisted_149 = { key: 4 }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_151 = { key: 5 }
const _hoisted_152 = { key: 6 }
const _hoisted_153 = {
  key: 1,
  class: "text-center"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Notes", -1))
const _hoisted_155 = { class: "" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Please remember to add your name at the end of the tenant note", -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_158 = { key: 0 }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Rental", -1))
const _hoisted_160 = ["value"]
const _hoisted_161 = /*#__PURE__*/_createTextVNode(" Please select a rental ")
const _hoisted_162 = ["disabled"]
const _hoisted_163 = ["disabled"]
const _hoisted_164 = { class: "note-body" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_166 = { key: 5 }
const _hoisted_167 = { key: 2 }

import { computed, ref, onMounted, watch } from "vue";

import api from "@virgodev/bazaar/functions/api";

import {
  ReservationInterface,
  // eslint-disable-next-line
  LedgerInterface,
  RentalInterface,
  lineItemInterface,
  PaymentsInterface,
} from "@/types/customers";
import BaseSpinner from "@/components/BaseSpinner.vue";
import OutstandingFeeBanner from "@/components/OutstandingFeeBanner.vue";
interface CloseReason {
  id: string | number;
  kind: string;
  reason: string;
}
interface DetailPayment extends Omit<PaymentsInterface, "invoice_id"> {
  payer_items?: Array<{ invoice_id: string | number }>;
  invoice_id?: string | number;
  added?: boolean;
}
import { storeToRefs } from "pinia";
import moment from "moment";
import { useStore } from "../../store";

export default /*#__PURE__*/_defineComponent({
  props: {
  id: {
    type: String,
    default: null,
  },
  facilityId: {
    type: String,
    default: null,
  },
  contactId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const customer = ref();
const deleteBox = ref(null);
const editKey = ref(null);
const submittingKey = ref(false);
const newGateKey = ref();
const ledgerInactiveBilling = ref<string[]>([]);
const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;
const isCubbyFacility = computed(() =>
  userData.value.chosenFacility.api_name?.toLowerCase().includes("cubby")
);
const historyWithoutRental = computed(() =>
  (userData.value.chosenFacility.api_name || "")
    .toLowerCase()
    .replace(/[-_ ]/g, "")
    .includes("ccstorage")
);
const moveIns = ref(Array<RentalInterface>());
const errors = ref("");
const rentals = ref();
const noteBody = ref("");
const notes = ref(
  Array<{ id?: number; note: string; created_at?: string | null }>()
);
const lineItems = ref();
const status = ref("loading");
const balance = ref();
const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);
const reservations = ref(Array<ReservationInterface>());
const selectedReserved = ref();
const selectedCloseReason = ref<CloseReason>();
const showDelete = ref(false);
const reasons = ref(Array<CloseReason>());
const payments = ref(Array<DetailPayment>());
const customerLien = ref(false);
const customerAuction = ref(false);
const customerDelinquent = ref(false);
const lineItemStatus = ref(false);
const requireLedgerId = ref(false);
const selectedRental = ref();
const showNoteError = ref(false);
// const rentals = ref([]);
// const items: Item[] = [];


async function loadCustomerPage() {
  status.value = "loading";
  customer.value = null;
  rentals.value = [];
  lineItems.value = [];
  notes.value = [];
  payments.value = [];
  lineItemStatus.value = false;
  customerLien.value = false;
  customerAuction.value = false;
  customerDelinquent.value = false;
  balance.value = 0;
  ledgerInactiveBilling.value = [];
  errors.value = "";
  if (api_settings.show_cancel_reasons) {
    getReasons();
  }
  await getCustomer();
  if (lineItems.value) {
    for (let item of lineItems.value) {
      let totalInvoices = ref(Array<lineItemInterface>());
      for (let invoice of item.invoices) {
        invoice.payments = [];
        if (payments.value && payments.value.length) {
          for (let payment of payments.value) {
            let payerItems = [];
            if (payment.payer_items) {
              payerItems = payment.payer_items.filter(
                (item: { invoice_id: string | number }) =>
                  item.invoice_id == invoice.id
              );
            } else {
              if (payment.invoice_id == invoice.id) {
                payerItems = payments.value.filter(
                  (item: { invoice_id?: string | number }) =>
                    payment.invoice_id == item.invoice_id
                );
              }
            }
            if (payerItems.length) {
              if (!invoice.payments.includes(payment) && !payment.added) {
                invoice.payments.push(payment);
                payment.added = true;
              }
            }
          }
        }
        for (let line of invoice.line_items) {
          if (invoice.created_at) {
            line.effective_on = invoice.created_at;
          }
          if (invoice.account_balance_on_due_date) {
            line.account_balance_on_due_date =
              invoice.account_balance_on_due_date;
          }
        }
        invoice.line_items = invoice.line_items.concat(invoice.payments);
        totalInvoices.value = totalInvoices.value.concat(invoice.line_items);
      }

      item.total_invoices = totalInvoices.value
        .sort(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          (a: { effective_on: string }, b: { effective_on: string }) =>
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            moment(a.effective_on).format("YYYYMMDD") -
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            moment(b.effective_on).format("YYYYMMDD")
        )
        .reverse();
      lineItemStatus.value = true;
    }
  }
}

onMounted(() => {
  loadCustomerPage();
});
watch(
  () => [props.id, props.contactId, props.facilityId],
  (_next, prev) => {
    if (!prev) return;
    loadCustomerPage();
  }
);

async function getCustomer() {
  errors.value = "";
  let customer_id = props.id;
  if (props.contactId) {
    customer_id = props.contactId;
  }
  const response = await api({
    url: `customers/?id=${customer_id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customer.value = response.body[0];
    if (api_settings.other_tenant_info) {
      if (api_settings.use_contact_id) {
        await getNotes(customer.value.contact_id);
      } else {
        await getMoveIns();
        await getPayments(props.id);
        await getNotes(props.id);
      }
    }
    await getLedgers();
    await getReservations();
    await getInvoices();
    status.value = "loaded";
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
    status.value = "loaded";
  }
}
async function cancelMoveOut(id: string, scheduled_id: string) {
  const json = JSON.parse(
    JSON.stringify({
      move_out: {
        unit_id: id,
        tenant_id: props.id,
      },
    })
  );
  let url = `schedule_move_out/?facilityId=${props.facilityId}&id=${scheduled_id}`;

  errors.value = "";
  const response = await api({
    url: url,
    method: "PUT",
    json,
  });
  if (response.status == 200) {
    deleteBox.value = null;
    await getLedgers();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function updateKey() {
  errors.value = "";
  submittingKey.value = true;
  const response = await api({
    url: `update_access_code/?id=${editKey.value}&facilityId=${props.facilityId}&contact_id=${customer.value.id}`,
    method: "PATCH",
    json: JSON.parse(
      JSON.stringify({
        gate_access_code: newGateKey.value,
      })
    ),
  });
  if (response.status == 200) {
    let rental = rentals.value.findIndex(
      (item: { id: number }) => item.id == editKey.value
    );
    rentals.value[rental].gate_access_code = newGateKey.value;
    editKey.value = null;
    newGateKey.value = "";
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  submittingKey.value = false;
}
async function submitForm() {
  status.value = "loading";
  let json = ref({});
  if (api_settings.show_cancel_reasons) {
    json = JSON.parse(
      JSON.stringify({
        lead: {
          close_reason_id: selectedCloseReason.value?.id,
        },
      })
    );
  } else {
    json = JSON.parse(
      JSON.stringify({
        needed: selectedReserved.value.desired_move_in_date.replace(" ", "T"),
        customer_id: selectedReserved.value.customer_id,
      })
    );
  }

  errors.value = "";
  const response = await api({
    url: `reservations/?id=${selectedReserved.value.id}&facilityId=${props.facilityId}`,
    method: "DELETE",
    json,
  });
  if (response.status == 200) {
    reservations.value.splice(
      reservations.value.indexOf(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        reservations.value.find(
          (item: ReservationInterface) => item == selectedReserved.value
        )
      ),
      1
    );
    status.value = "loaded";
    selectedReserved.value = "";
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getReservations() {
  errors.value = "";
  let response;
  if (api_settings.use_contact_id) {
    reservations.value = customer.value.reservations;
  } else {
    if (customer.value.lead_ids && customer.value.lead_ids.length != 0) {
      response = await api({
        url: `reservations/?only_ids=${customer.value.lead_ids.join(
          ","
        )}&facilityId=${props.facilityId}`,
      });
    } else {
      response = await api({
        url: `reservations/?facilityId=${props.facilityId}&id=${props.id}`,
      });
    }
    if (response.status == 200) {
      if (response.body.leads) {
        reservations.value = response.body.leads;
      } else {
        reservations.value = response.body;
      }
    } else {
      errors.value =
        "Unable to communicate with the server. Please check your " +
        "connection and try again.";
    }
  }
}
async function createNote(id: string) {
  const json = JSON.parse(JSON.stringify({ note_text: noteBody.value }));
  if (api_settings.ledger_with_note) {
    showNoteError.value = false;
    if (!selectedRental.value) {
      showNoteError.value = true;
      return;
    }
  }
  formErrors.value = {};
  formSubmitting.value = true;
  if (api_settings.use_contact_id && !api_settings.ledger_with_note) {
    id = customer.value.contact_id;
  }
  let url = "notes/?id=" + id + `&facilityId=${props.facilityId}`;
  if (api_settings.lead_id_with_notes) {
    url += `&leadId=${customer.value.lead_id}`;
  }
  let method: "POST" | "PATCH" = "POST";
  const response = await api({
    url,
    method,
    json,
  });

  if ([200].includes(response.status)) {
    let note;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (response.body.note_event) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      note = response.body.note_event;
      notes.value.unshift({
        id: note.id,
        note: note.notes[0].note,
        created_at: note.notes[0].created_at,
      });
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      note = response.body;
      notes.value.unshift({
        id: note.id,
        note: note.note || json.note_text,
        created_at: note.created_at,
      });
    }
    noteBody.value = "";
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
  formSubmitting.value = false;
}
async function getReasons() {
  errors.value = "";
  const response = await api({
    url: `reasons/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    reasons.value = response.body.reasons;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getLedgers() {
  errors.value = "";
  let response;
  balance.value = 0;
  if (!api_settings.use_contact_id) {
    if (
      customer.value.current_ledger_ids &&
      !api_settings.customer_id_with_ledgers
    ) {
      response = await api({
        url: `ledgers/?only_ids=${customer.value.current_ledger_ids.join(
          ","
        )}&include_as_object=events&facilityId=${props.facilityId}`,
      });
    } else {
      response = await api({
        url: `ledgers/?id=${props.id}&facilityId=${props.facilityId}`,
      });
    }

    if (response.status == 200) {
      if (response.body.ledgers) {
        rentals.value = response.body.ledgers;
      } else {
        rentals.value = response.body;
        // await getAccountBalance();
        customer.value.current_ledger_ids = [];
        payments.value = [];
        for (let rental of rentals.value) {
          customer.value.current_ledger_ids.push(rental.id);
          await getPayments(rental.id);
        }
        // No current rental: ask for the customer's own payments and notes so
        // a former tenant's history does not disappear along with their unit.
        if (rentals.value.length == 0 && historyWithoutRental.value) {
          await getPayments(props.id, false, true);
          if (api_settings.ledger_with_note) {
            await getNotes(props.id, true);
          }
        }
        // StorEdge refills notes from ledger events. CC Storage (and others
        // with ledger_with_note off) already loaded customer notes; wiping
        // them here leaves the Notes section empty.
        if (api_settings.ledger_with_note) {
          notes.value = [];
        }
      }
    } else {
      errors.value =
        "Unable to communicate with the server. Please check your " +
        "connection and try again.";
    }
    if (
      notes.value &&
      notes.value.length > 0 &&
      api_settings.ledger_with_note
    ) {
      let items = notes.value;
      notes.value = items
        .sort(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          (a: { created_at: string }, b: { created_at: string }) =>
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            moment(a.created_at).format("YYYYMMDD") -
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            moment(b.created_at).format("YYYYMMDD")
        )
        .reverse();
    }
  } else {
    rentals.value = customer.value.rentals;
    customer.value.current_ledger_ids = [];
    payments.value = [];
    for (let rental of rentals.value) {
      customer.value.current_ledger_ids.push(rental.id);
      await getPayments(rental.id, true);
    }
  }
  updateUnits();
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
async function updateUnits() {
  balance.value = 0;
  for (let rental of rentals.value) {
    rental.unit.status = rental.unit.status.toLowerCase();
    if (rental.unit && rental.unit.status) {
      if (rental.unit.status == "lien") {
        customerLien.value = true;
      }
      if (!rental.autopay_enabled) {
        ledgerInactiveBilling.value.push(rental.unit.name);
      }
      if (rental.auction_id) {
        customerAuction.value = true;
      }

      if (rental.delinquent && rental.active) {
        customerDelinquent.value = true;
      }
      if (rental.current_account_balance) {
        balance.value += Number(rental.current_account_balance);
      }
    }
    if (api_settings.ledger_with_note) {
      await getNotes(rental.id);
      requireLedgerId.value = true;
    }
  }
}
async function getMoveIns() {
  errors.value = "";
  const response = await api({
    url: `move_ins/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    moveIns.value = response.body.move_ins.filter(
      (item: RentalInterface) => item.tenant_id == props.id
    );
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
// async function getAccountBalance() {
//   errors.value = "";
//   const response = await api({
//     url: `account_balance/?facilityId=${props.facilityId}&id=${props.id}`,
//   });
//   if (response.status == 200) {
//     let balance_list = response.body;
//     let total_balance = 0;
//     for (let item of balance_list) {
//       total_balance += Number(item.total);
//     }
//     balance.value = Number(total_balance);
//   } else {
//     errors.value =
//       "Unable to communicate with the server. Please check your " +
//       "connection and try again.";
//   }
// }
async function getNotes(id: string, optional = false) {
  errors.value = "";
  const response = await api({
    url: `notes/?id=${id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    if (response.body && response.body.notes) {
      notes.value = response.body.notes;
    } else {
      notes.value = notes.value.concat(response.body);
      let insuranceSelfInsured = notes.value.filter(
        (item: { note: string }) => item.note == "Proof of Insurance added"
      )[0];
      if (insuranceSelfInsured) {
        let index = rentals.value.findIndex(
          (item: { id: string }) => item.id == id
        );
        rentals.value[index].current_insurance = {
          description: "Proof of insurance added",
        };
      }
    }
  } else if (!optional) {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getLeaseAgreement() {
  errors.value = "";
  const response = await api({
    url: `lease_agreement/?id=${props.id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    let leases = response.body;
    for (let rental of rentals.value) {
      rental.lease_agreement = leases.filter(
        (item: { id: number; lease_signed_at: string }) =>
          item.id == rental.id && item.lease_signed_at
      )[0];
    }
  }
}
function billingHeading(ledgerId: string | number) {
  const match = (rentals.value || []).find(
    (ledger: LedgerInterface) => ledger.id == ledgerId
  );
  return match && match.unit && match.unit.name
    ? `Unit ${match.unit.name} Billing`
    : "Billing";
}
async function getInvoices() {
  errors.value = "";
  lineItems.value = [];

  let ledgerIds = customer.value.current_ledger_ids || [];
  const byCustomer = ledgerIds.length == 0 && historyWithoutRental.value;
  if (byCustomer) {
    ledgerIds = [props.id];
  }

  if (ledgerIds.length != 0) {
    let leases = false;
    for (let ledgerId of ledgerIds) {
      const response = await api({
        url: `invoices/?id=${ledgerId}&facilityId=${props.facilityId}`,
        method: "GET",
      });
      if (response.status == 200) {
        let invoice_list = [];
        if (response.body.invoices) {
          invoice_list = response.body.invoices;
        } else {
          invoice_list = [
            {
              id: ledgerId,
              line_items: response.body,
            },
          ];
        }
        lineItems.value.push({
          ledger_id: ledgerId,
          invoices: invoice_list,
        });
        if (!leases && !response.body.invoices) {
          await getLeaseAgreement();
          leases = true;
        }
      } else {
        lineItems.value.push({
          ledger_id: ledgerId,
          invoices: [{ id: ledgerId, line_items: [] }],
        });
        if (!byCustomer) {
          errors.value =
            "Unable to communicate with the server. Please check your " +
            "connection and try again.";
        }
      }
    }
  }
}

function collectPayments(rows: DetailPayment[]) {
  const seen = new Set(
    payments.value
      .filter((payment) => payment.id !== undefined && payment.id !== null)
      .map((payment) => String(payment.id))
  );
  for (const row of rows || []) {
    if (row.id !== undefined && row.id !== null) {
      const key = String(row.id);
      if (seen.has(key)) continue;
      seen.add(key);
    }
    payments.value.push(row);
  }
}
async function getPayments(id: string, multiple = false, optional = false) {
  errors.value = "";
  const response = await api({
    url: `payments/?id=${id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    if (response.body.payments) {
      if (multiple) {
        collectPayments(response.body.payments);
      } else {
        payments.value = [];
        payments.value = response.body.payments;
      }
    } else {
      for (let item of response.body) {
        item.invoice_id = id;
      }
      collectPayments(response.body);
    }
  } else if (!optional) {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 0,
          preset: "large"
        }))
      : _createCommentVNode("", true),
    (customer.value && status.value === 'loaded')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", null, _toDisplayString(customer.value.first_name) + " " + _toDisplayString(customer.value.last_name), 1),
          _createVNode(OutstandingFeeBanner, {
            "facility-id": __props.facilityId,
            "customer-id": __props.id
          }, null, 8, ["facility-id", "customer-id"]),
          _createVNode(_component_RouterLink, {
            to: {
          name: 'payment_storedge',
          params: {
            customerId: customer.value.id,
            customerName: customer.value.first_name + ' ' + customer.value.last_name,
            facilityId: __props.facilityId,
          },
        },
            class: "btn btn-text"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["to"]),
          (_unref(api_settings).allow_credit)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: {
          name: 'credit',
          params: {
            customerId: customer.value.contact_id,
            customerName: customer.value.first_name + ' ' + customer.value.last_name,
            facilityId: __props.facilityId,
          },
        },
                class: "btn btn-text"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (_unref(api_settings).show_fees_products)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 1,
                to: {
          name: 'invoice_fees',
          params: {
            customerId: customer.value.id,
            customerName: customer.value.first_name + ' ' + customer.value.last_name,
            facilityId: __props.facilityId,
          },
        },
                class: "btn btn-text"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createVNode(_component_RouterLink, {
            to: {
          name: 'customer_storedge',
          params: _unref(api_settings).use_contact_id
            ? {
                customerId: customer.value.contact_id,
                facilityId: __props.facilityId,
              }
            : {
                customerId: __props.id,
                facilityId: __props.facilityId,
              },
        },
            class: "btn btn-text"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_RouterLink, {
            to: {
          name: 'rental_storedge',
          params: {
            customerId: __props.id,
            facilityId: __props.facilityId,
          },
        },
            class: "btn btn-text"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_8, [
            (customerLien.value)
              ? (_openBlock(), _createBlock(_component_BaseAlert, {
                  key: 0,
                  variant: "danger",
                  class: "js-form-error"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (customerAuction.value)
              ? (_openBlock(), _createBlock(_component_BaseAlert, {
                  key: 1,
                  variant: "danger",
                  class: "js-form-error"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (customerDelinquent.value)
              ? (_openBlock(), _createBlock(_component_BaseAlert, {
                  key: 2,
                  variant: "danger",
                  class: "js-form-error"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (customer.value.notes)
              ? (_openBlock(), _createBlock(_component_BaseAlert, {
                  key: 3,
                  variant: "danger",
                  class: "js-form-error"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("b", null, " Note: " + _toDisplayString(customer.value.notes), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _hoisted_12,
          (customer.value.archived_at)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Archived at " + _toDisplayString(customer.value.archived_at), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            (_unref(api_settings).photo_upload)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("fieldset", _hoisted_17, [
                    _createElementVNode("img", {
                      src: customer.value.photo_identification,
                      class: "photo-id"
                    }, null, 8, _hoisted_18),
                    _createVNode(_component_RouterLink, {
                      to: {
                name: 'customer_photos',
                params: {
                  customerId: customer.value.id,
                  customerName: customer.value.first_name + ' ' + customer.value.last_name,
                  facilityId: __props.facilityId,
                },
              }
                    }, {
                      default: _withCtx(() => [
                        (!customer.value.photo_identification)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_19
                            ], 64))
                          : (_openBlock(), _createElementBlock("button", _hoisted_20, "See More"))
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("fieldset", null, [
                (customer.value.account_number)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_23,
                      _createElementVNode("p", null, _toDisplayString(customer.value.account_number), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _hoisted_24,
                _createElementVNode("p", null, _toDisplayString(customer.value.first_name) + " " + _toDisplayString(customer.value.last_name), 1),
                _hoisted_25,
                _createElementVNode("p", null, _toDisplayString(customer.value.email), 1),
                (customer.value.access_code)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_26,
                      _createElementVNode("p", null, _toDisplayString(customer.value.access_code), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _hoisted_27,
                (customer.value.phone_numbers)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(customer.value.phone_numbers, (phone) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: phone.id + 'phone'
                      }, [
                        (phone.formatted_number)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                              _createTextVNode(_toDisplayString(phone.formatted_number) + " - " + _toDisplayString(phone.label) + " ", 1),
                              _hoisted_29
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true),
                (customer.value.formatted_phone)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(_toDisplayString(customer.value.formatted_phone), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _hoisted_30,
                (customer.value.formatted_cell_phone)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createTextVNode(_toDisplayString(customer.value.formatted_cell_phone), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _hoisted_31,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.value.addresses, (address) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: address.id + 'phone'
                  }, [
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(address.full_address) + " ", 1),
                      (address.label)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("- " + _toDisplayString(address.label), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_32
                  ]))
                }), 128)),
                _hoisted_33,
                _createElementVNode("p", null, _toDisplayString(customer.value.drivers_license_number), 1),
                (customer.value.vehicle_license_plate_number)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      _hoisted_34,
                      _createElementVNode("p", null, _toDisplayString(customer.value.vehicle_license_plate_number), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (customer.value.vehicle_description)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _hoisted_35,
                      _createElementVNode("p", null, _toDisplayString(customer.value.vehicle_description), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_RouterLink, {
                  to: {
                name: 'customer_storedge',
                params: { customerId: __props.id, facilityId: __props.facilityId },
              },
                  class: "btn btn-text"
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            (_unref(api_settings).allow_password)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("fieldset", null, [
                    (customer.value.username)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_39,
                          _createElementVNode("p", null, _toDisplayString(customer.value.username), 1)
                        ], 64))
                      : (customer.value.web_password)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_40
                          ], 64))
                        : (_openBlock(), _createElementBlock("p", _hoisted_41, _hoisted_45))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(ledgerInactiveBilling.value.length != 0 ? 'alert-box-2' : '')
          }, [
            (ledgerInactiveBilling.value.length == 0)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_46, "Active Recurring Billing Accounts"))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" Inactive Recurring Billing Accounts for the following units: " + _toDisplayString(ledgerInactiveBilling.value.join(",")), 1)
                ], 64))
          ], 2),
          _createElementVNode("div", _hoisted_47, [
            (balance.value)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_48, "Balance: $" + _toDisplayString(Number(balance.value).toFixed(2)), 1))
              : (_openBlock(), _createElementBlock("h2", _hoisted_49, "Balance: $0.00"))
          ]),
          _createVNode(_component_RouterLink, {
            to: {
          name: 'payment_storedge',
          params: {
            customerId: customer.value.id,
            customerName: customer.value.first_name + ' ' + customer.value.last_name,
            facilityId: __props.facilityId,
          },
        },
            class: "btn btn-text"
          }, {
            default: _withCtx(() => [
              _hoisted_50
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_RouterLink, {
            class: "btn btn-text",
            to: {
          name: 'payment_details_storedge',
          params: {
            customerId: customer.value.id,
            customerName: customer.value.first_name + ' ' + customer.value.last_name,
            facilityId: __props.facilityId,
          },
        }
          }, {
            default: _withCtx(() => [
              (_unref(api_settings).allow_autopay_changes)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_51
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_52
                  ], 64)),
              _hoisted_53
            ]),
            _: 1
          }, 8, ["to"]),
          _hoisted_54,
          _createElementVNode("div", _hoisted_55, [
            (customerLien.value)
              ? (_openBlock(), _createBlock(_component_BaseAlert, {
                  key: 0,
                  variant: "danger",
                  class: "js-form-error"
                }, {
                  default: _withCtx(() => [
                    _hoisted_56
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (customerAuction.value)
              ? (_openBlock(), _createBlock(_component_BaseAlert, {
                  key: 1,
                  variant: "danger",
                  class: "js-form-error"
                }, {
                  default: _withCtx(() => [
                    _hoisted_57
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (customerDelinquent.value)
              ? (_openBlock(), _createBlock(_component_BaseAlert, {
                  key: 2,
                  variant: "danger",
                  class: "js-form-error"
                }, {
                  default: _withCtx(() => [
                    _hoisted_58
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("fieldset", null, [
            (rentals.value && rentals.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rentals.value, (rental) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: rental.id + 'rental',
                      class: "rental-box"
                    }, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", null, [
                          _hoisted_61,
                          _createElementVNode("h3", null, [
                            (rental.unit && rental.unit.id)
                              ? (_openBlock(), _createBlock(_component_RouterLink, {
                                  key: 0,
                                  to: {
                      name: 'unit_detail_storedge',
                      params: {
                        id: rental.unit.id,
                        facilityId: __props.facilityId,
                      },
                    }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(rental.unit.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(rental.unit ? rental.unit.name : ""), 1)
                                ], 64))
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_62,
                          (rental.lease_agreement)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_63, " Signed at " + _toDisplayString(_unref(moment)(rental.lease_agreement.lease_signed_at).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )), 1))
                            : (_openBlock(), _createElementBlock("h3", _hoisted_64, " Unsigned "))
                        ]),
                        _hoisted_65,
                        _createElementVNode("div", null, [
                          _hoisted_66,
                          (rental.unit.size)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_67,
                                _createElementVNode("p", null, "Size: " + _toDisplayString(rental.unit.size), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (rental.unit.status)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_68,
                                _createElementVNode("p", null, _toDisplayString(rental.unit.status), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _hoisted_69,
                          _createTextVNode(" " + _toDisplayString(rental.gate_access_code) + " ", 1),
                          (_unref(api_settings).update_gate_access_code)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (!editKey.value)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "btn",
                                      onClick: ($event: any) => (
                        (editKey.value = rental.id),
                          (newGateKey.value = rental.gate_access_code)
                      )
                                    }, [
                                      (
                          rental.gate_access_code &&
                          rental.gate_access_code.length
                        )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _hoisted_71
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _hoisted_72
                                          ], 64))
                                    ], 8, _hoisted_70))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (editKey.value == rental.id)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_73, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newGateKey).value = $event)),
                                              type: "text"
                                            }, null, 512), [
                                              [_vModelText, newGateKey.value]
                                            ]),
                                            _createElementVNode("button", {
                                              class: "btn",
                                              onClick: _cache[1] || (_cache[1] = ($event: any) => (updateKey()))
                                            }, [
                                              _hoisted_74,
                                              (submittingKey.value)
                                                ? (_openBlock(), _createBlock(BaseSpinner, { key: 0 }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("button", {
                                              class: "btn",
                                              onClick: _cache[2] || (_cache[2] = ($event: any) => (editKey.value = null))
                                            }, " Cancel ")
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                              ], 64))
                            : _createCommentVNode("", true),
                          (_unref(isCubbyFacility))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _hoisted_75,
                                _createElementVNode("p", null, _toDisplayString(rental.unit.access_instructions), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (
                    _unref(api_settings).combination_lock_number &&
                    (!_unref(isCubbyFacility) || rental.unit.combination_lock_number)
                  )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _hoisted_76,
                                _createElementVNode("p", null, _toDisplayString(rental.unit.combination_lock_number), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _hoisted_77,
                          (rental.moved_in_at)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_78, [
                                (rental.moved_in_at.includes('T'))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(rental.moved_in_at.split("T")[0]), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(rental.moved_in_at.split(" ")[0]), 1)
                                    ], 64))
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_79,
                          (rental.current_insurance)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_80, _toDisplayString(rental.current_insurance.description), 1))
                            : (rental.self_insured_policy_number)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                  _hoisted_82,
                                  _createElementVNode("p", _hoisted_83, [
                                    _createTextVNode(" Policy Number: " + _toDisplayString(rental.self_insured_policy_number) + " ", 1),
                                    _hoisted_84,
                                    _createTextVNode(" Expiration: " + _toDisplayString(rental.self_insured_policy_expires_on), 1)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_85, "No plan")),
                          (_unref(api_settings).rental_update_allowed)
                            ? (_openBlock(), _createBlock(_component_RouterLink, {
                                key: 9,
                                class: "btn",
                                to: {
                    name: 'rental_update',
                    params: {
                      customerId: __props.id,
                      rentalId: rental.id,
                      unitType: rental.unit_group_id,
                      facilityId: __props.facilityId,
                    },
                  }
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_86
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_87,
                          _createElementVNode("h5", null, " $" + _toDisplayString(Number(rental.current_rate).toFixed(2)) + " each month ", 1),
                          (rental.next_charge_date)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_88,
                                _createElementVNode("p", null, _toDisplayString(_unref(moment)(rental.next_charge_date).format("YYYY-MM-DD")), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _hoisted_89,
                          (
                    rental.paid_through && _unref(moment)(rental.paid_through).isValid()
                  )
                            ? (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString(_unref(moment)(rental.paid_through).format("YYYY-MM-DD")), 1))
                            : (_openBlock(), _createElementBlock("p", _hoisted_91, "—")),
                          _hoisted_92,
                          (rental.balance)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_93, " $" + _toDisplayString(Number(rental.balance).toFixed(2)), 1))
                            : (rental.current_account_balance)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_94, " $" + _toDisplayString(Number(rental.current_account_balance).toFixed(2)), 1))
                              : _createCommentVNode("", true),
                          (_unref(api_settings).rental_increase_scheduled)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                _hoisted_95,
                                (rental.scheduled_rate_change)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_96, " $" + _toDisplayString(rental.scheduled_rate_change.new_rate) + " effective on " + _toDisplayString(rental.scheduled_rate_change.effective_on), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        (rentals.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                              _hoisted_98,
                              _createElementVNode("div", null, [
                                (rental.scheduled_move_out)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                      _createElementVNode("h3", null, " Move-out Scheduled: " + _toDisplayString(rental.scheduled_move_out.desired_move_out_date), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (rental.scheduled_move_out)
                                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                                      key: 1,
                                      class: "btn",
                                      to: {
                      name: 'schedule_move_out_storedge',
                      params: {
                        customerId: customer.value.id,
                        rentalId: rental.unit.id,
                        customerName:
                          customer.value.first_name + ' ' + customer.value.last_name,
                        unitName: rental.unit.name,
                        ledgerId: rental.id,
                        unitsLeft: 0,
                        edit: 0,
                        facilityId: __props.facilityId,
                        scheduledId: rental.scheduled_move_out.id,
                        unitTypeId: rental.unit_group_id,
                      },
                    }
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_100
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : (_openBlock(), _createBlock(_component_RouterLink, {
                                      key: 2,
                                      class: "btn",
                                      to: {
                      name: 'schedule_move_out_storedge',
                      params: {
                        customerId: customer.value.id,
                        rentalId: rental.unit.id,
                        customerName:
                          customer.value.first_name + ' ' + customer.value.last_name,
                        unitName: rental.unit.name,
                        ledgerId: rental.id,
                        unitsLeft: 0,
                        edit: 0,
                        facilityId: __props.facilityId,
                      },
                    }
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_101
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])),
                                (rental.scheduled_move_out)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                      _createVNode(_component_RouterLink, {
                                        class: "btn",
                                        to: {
                        name: 'schedule_move_out_storedge',
                        params: {
                          customerId: customer.value.id,
                          rentalId: rental.unit.id,
                          customerName:
                            customer.value.first_name + ' ' + customer.value.last_name,
                          unitName: rental.unit.name,
                          ledgerId: rental.id,
                          unitsLeft: 0,
                          edit: 1,
                          facilityId: __props.facilityId,
                        },
                      }
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_103
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]),
                                      (_unref(api_settings).cancel_move_out)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (deleteBox.value == rental.unit.id)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                                  _hoisted_105,
                                                  _createElementVNode("div", {
                                                    class: "btn btn-primary",
                                                    onClick: ($event: any) => (
                            cancelMoveOut(
                              rental.unit.id,
                              rental.scheduled_move_out.id
                            )
                          )
                                                  }, " Yes ", 8, _hoisted_106),
                                                  _createElementVNode("div", {
                                                    class: "btn btn-primary",
                                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (deleteBox.value = null))
                                                  }, " No ")
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", {
                                                  key: 1,
                                                  class: "btn",
                                                  onClick: ($event: any) => (deleteBox.value = rental.unit.id)
                                                }, " Cancel ", 8, _hoisted_107))
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_108, "No items yet"))
          ]),
          (_unref(api_settings).show_reservations)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_109, "Reservations"))
            : _createCommentVNode("", true),
          (_unref(api_settings).show_reservations)
            ? (_openBlock(), _createElementBlock("fieldset", _hoisted_110, [
                (reservations.value && reservations.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reservations.value, (reservation) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'reservation' + reservation.id,
                          class: "rental-box"
                        }, [
                          (reservation.status == 'reserved')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                _createElementVNode("div", null, [
                                  _hoisted_113,
                                  _createElementVNode("h3", null, _toDisplayString(reservation.unit.name), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _hoisted_114,
                                  _hoisted_115,
                                  (reservation.unit_group)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_116, _toDisplayString(reservation.unit_group.size), 1))
                                    : (reservation.unit.size)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_117, _toDisplayString(reservation.unit.size), 1))
                                      : _createCommentVNode("", true),
                                  _hoisted_118,
                                  _createElementVNode("p", null, _toDisplayString(reservation.created_at), 1),
                                  _hoisted_119,
                                  _createElementVNode("p", null, _toDisplayString(reservation.desired_move_in_date), 1)
                                ]),
                                (reservation.unit.status == 'reserved')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                      (_unref(api_settings).complete_reservations)
                                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                                            key: 0,
                                            class: "btn",
                                            to: {
                    name: 'rental_storedge',
                    params: _unref(api_settings).tenant_search_with_reservations
                      ? {
                          facilityId: __props.facilityId,
                          customerId: __props.id,
                          unitType: reservation.unit_type.id,
                          unitId: reservation.unit.id,
                          reservationId: reservation.id,
                          unitStatus: 'reserved',
                        }
                      : {
                          facilityId: __props.facilityId,
                          customerId: __props.id,
                          unitType: reservation.unit_type.id,
                          unitId: reservation.unit.id,
                          reservationId: reservation.id,
                          unitStatus: 'reserved',
                        },
                  }
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_121
                                            ]),
                                            _: 2
                                          }, 1032, ["to"]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("button", {
                                        class: "btn",
                                        onClick: ($event: any) => ((showDelete.value = true), (selectedReserved.value = reservation))
                                      }, " Cancel ", 8, _hoisted_122),
                                      (showDelete.value && selectedReserved.value.id == reservation.id)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                            _hoisted_124,
                                            _createElementVNode("div", _hoisted_125, [
                                              _createElementVNode("form", {
                                                onSubmit: _withModifiers(submitForm, ["prevent"])
                                              }, [
                                                (_unref(api_settings).show_cancel_reasons)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                                      _hoisted_128,
                                                      _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedCloseReason).value = $event)),
                                                        class: "form-select",
                                                        required: ""
                                                      }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reasons.value, (reason) => {
                                                          return (_openBlock(), _createElementBlock(_Fragment, {
                                                            key: reason.id + 'reason'
                                                          }, [
                                                            (reason.kind == 'close')
                                                              ? (_openBlock(), _createElementBlock("option", {
                                                                  key: 0,
                                                                  value: reason
                                                                }, _toDisplayString(reason.reason), 9, _hoisted_129))
                                                              : _createCommentVNode("", true)
                                                          ], 64))
                                                        }), 128))
                                                      ], 512), [
                                                        [_vModelSelect, selectedCloseReason.value]
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _hoisted_130,
                                                _createElementVNode("div", {
                                                  class: "btn btn-outline-blue",
                                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (showDelete.value = false))
                                                }, " Cancel ")
                                              ], 40, _hoisted_126)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_131, "No items yet"))
              ]))
            : _createCommentVNode("", true),
          _hoisted_132,
          _createElementVNode("fieldset", _hoisted_133, [
            (lineItems.value && lineItems.value.length)
              ? (_openBlock(), _createElementBlock("table", _hoisted_134, [
                  _hoisted_135,
                  (lineItemStatus.value)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(lineItems.value, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item.id + 'item'
                        }, [
                          (rentals.value)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_136, _toDisplayString(billingHeading(item.ledger_id)), 1))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.total_invoices, (invoice) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: invoice.id + 'invoice'
                            }, [
                              (!invoice.full_description)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (invoice.effective_on)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_137, [
                                          (_unref(api_settings).refunds)
                                            ? (_openBlock(), _createBlock(_component_RouterLink, {
                                                key: 0,
                                                to: {
                            name: 'transaction',
                            params: {
                              transactionId: invoice.id,
                              customerId: customer.value.id,
                              customerName: customer.value.name,
                              facilityId: __props.facilityId,
                            },
                          }
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(invoice.effective_on.split("T")[0]), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["to"]))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(_toDisplayString(invoice.effective_on.split("T")[0]), 1)
                                              ], 64))
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("td", null, _toDisplayString(invoice.description), 1),
                                    _hoisted_138,
                                    _hoisted_139,
                                    _hoisted_140,
                                    (invoice.amount.toString().includes('-'))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_141, " $" + _toDisplayString(Number(invoice.amount.toString().split("-")[1]).toFixed(
                          2
                        )), 1))
                                      : (_openBlock(), _createElementBlock("td", _hoisted_142, "$" + _toDisplayString(Number(invoice.amount).toFixed(2)), 1)),
                                    _hoisted_143
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (invoice.effective_on)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_144, [
                                          (_unref(api_settings).update_line_item)
                                            ? (_openBlock(), _createBlock(_component_RouterLink, {
                                                key: 0,
                                                to: {
                            name: 'line_item',
                            params: {
                              lineItemId: invoice.invoice_id,
                              customerId: customer.value.id,
                              customerName: customer.value.name,
                              facilityId: __props.facilityId,
                            },
                          }
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(invoice.effective_on.split("T")[0]), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["to"]))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(_toDisplayString(invoice.effective_on.split("T")[0]), 1)
                                              ], 64))
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("td", null, _toDisplayString(invoice.description), 1),
                                    (invoice.full_description.includes('('))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_145, _toDisplayString("(" + invoice.full_description.split("(")[1]), 1))
                                      : (_openBlock(), _createElementBlock("td", _hoisted_146, _toDisplayString(invoice.full_description), 1)),
                                    _hoisted_147,
                                    (!_unref(api_settings).use_contact_id)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_148, " $" + _toDisplayString(invoice.total.toFixed(2)), 1))
                                      : (_openBlock(), _createElementBlock("td", _hoisted_149, "$" + _toDisplayString(invoice.total), 1)),
                                    _hoisted_150,
                                    (invoice.account_balance_on_due_date)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_151, " $" + _toDisplayString(Number(invoice.account_balance_on_due_date).toFixed(2)), 1))
                                      : (_openBlock(), _createElementBlock("td", _hoisted_152))
                                  ], 64))
                            ]))
                          }), 128))
                        ], 64))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_153, "No items yet"))
          ]),
          _hoisted_154,
          _createElementVNode("fieldset", _hoisted_155, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((noteBody).value = $event))
            }, null, 512), [
              [_vModelText, noteBody.value]
            ]),
            _hoisted_156,
            _hoisted_157,
            (_unref(api_settings).ledger_with_note)
              ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                  _hoisted_159,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedRental).value = $event)),
                    class: "form-select",
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rentals.value, (rental) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: 'rentalnote' + rental.id,
                        value: rental.id
                      }, _toDisplayString(rental.unit.name), 9, _hoisted_160))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, selectedRental.value]
                  ])
                ]))
              : _createCommentVNode("", true),
            (showNoteError.value)
              ? (_openBlock(), _createBlock(_component_BaseAlert, {
                  key: 1,
                  variant: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_161
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!requireLedgerId.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn",
                  disabled: formSubmitting.value,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (createNote(props.id)))
                }, " Create Note ", 8, _hoisted_162))
              : (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "btn",
                  disabled: formSubmitting.value,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (createNote(selectedRental.value)))
                }, " Create Note ", 8, _hoisted_163)),
            (formSubmitting.value)
              ? (_openBlock(), _createBlock(BaseSpinner, { key: 4 }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
              return (_openBlock(), _createElementBlock("div", {
                key: (note.id || note.note) + 'note',
                class: "note"
              }, [
                _createElementVNode("div", _hoisted_164, [
                  _createTextVNode(_toDisplayString(note.created_at && _unref(moment)(note.created_at).isValid()
                ? _unref(moment)(note.created_at).format("M/DD/YYYY h:mm:ss A")
                : "Date unavailable"), 1),
                  _hoisted_165,
                  _createTextVNode(" " + _toDisplayString(note.note), 1)
                ])
              ]))
            }), 128))
          ]),
          (errors.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_166, _toDisplayString(errors.value), 1))
            : _createCommentVNode("", true)
        ]))
      : (errors.value && status.value === 'loaded')
        ? (_openBlock(), _createElementBlock("div", _hoisted_167, _toDisplayString(errors.value), 1))
        : _createCommentVNode("", true)
  ]))
}
}

})